import React from 'react';
import {onClickMemberShipButton} from '../data/filePath';


const sizes = {
  default: `py-3 px-8`,
  lg: `py-4 px-12`,
  xl: `py-5 px-16 text-lg`
};

const Button = ({ children, className = '', size }) => {
  return (
    <button
      type="button"
      className={`
        ${sizes[size] || sizes.default}
        ${className}
        bg-primary
        hover:bg-primary-darker
        rounded
        text-white
    `}
    onClick={() => onClickMemberShipButton()}
    >
      {children}
    </button>
  );
};

export default Button;
